export default __webpack_public_path__ + "static/media/kamperenKlein.36941960.jpg";